import PdfColor from './PdfColour.svg';
import PdfDark from './PdfDark.svg';
import PdfLight from './PdfLight.svg';
export const pdf = { color: PdfColor, dark: PdfDark, light: PdfLight };
//# sourceMappingURL=index.js.map